import { render, staticRenderFns } from "./LoginAsPartner.vue?vue&type=template&id=9d6d9b88&"
import script from "./LoginAsPartner.vue?vue&type=script&lang=js&"
export * from "./LoginAsPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports